var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 30.4c7.8 0 14.4-6.4 14.4-14.4S23.8 1.6 16 1.6 1.6 8.2 1.6 16 8.2 30.4 16 30.4m0-24.8c5.6 0 10.4 4.6 10.4 10.4S21.8 26.4 16 26.4 5.6 21.6 5.6 16 10.4 5.6 16 5.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9 7.8 6.5 9.2l16.6 16.6 2.8-2.8L9.3 6.4 6.5 9.2zL6.5 9.2l16.6 16.6 2.8-2.8L9.3 6.4 6.5 9.2z"
  })));
};
export default SvgCancel;